import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaHome,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const RealEstateVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Real Estate Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Showcase Your Properties</Subheading>}
        heading={
          <Heading>
            Real Estate <span tw="text-primary-500">Video Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in real estate video production in
            **Bur Dubai**, creating captivating, high-quality videos that
            highlight properties to attract buyers and investors.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1560184897-ae75f418493e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern Dubai property
          "https://images.unsplash.com/photo-1582610116397-edb318620f90?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury apartment in Dubai
          "https://images.unsplash.com/photo-1600607687644-c7f34b5063c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Elegant interior design
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Showcase Your Property"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Stunning Real Estate Videos in Bur Dubai"
        description="We craft videos that sell properties faster."
        cards={[
          {
            icon: <FaHome color="#ff5464" size={40} />,
            title: "Property Highlights",
            description: "Showcase homes, offices, or villas with flair.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition visuals for maximum appeal.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Turnaround",
            description: "Fast delivery to meet listing deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Videos tailored for websites and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Agents",
            description: "Bur Dubai’s choice for property videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Packages",
            description: "Solutions for single listings or portfolios.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Real Estate Video Process"
        description={
          <Description>
            We create compelling property videos with a seamless process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your property’s unique features.</li>
              <li>Planning: Develop a shot list to highlight key areas.</li>
              <li>
                Filming: Capture stunning visuals with drones and cameras.
              </li>
              <li>Editing: Add music, narration, and branding for impact.</li>
              <li>Delivery: Provide ready-to-share videos for listings.</li>
              <li>Support: Offer revisions to perfect your vision.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Property interior view
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern building exterior
          "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Stylish apartment living room
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Real Estate Video Wins in Bur Dubai"
        description="Our videos have driven property sales."
        cards={[
          {
            icon: <FaHome color="#ff5464" size={40} />,
            title: "Faster Sales",
            description: "Videos that attracted buyers quickly.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Agent Praise",
            description: "96% satisfaction from Bur Dubai realtors.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Wider Reach",
            description: "Listings shared across platforms.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell with Video?</Subheading>}
        heading="Real Estate Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert real estate video production
            in Bur Dubai. Get professional, captivating videos to showcase your
            properties—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury villa
          "https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern kitchen design
          "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Dubai skyline with property
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
